import PropTypes from 'prop-types';

export default class LookBookCollageList extends React.Component {
    static propTypes = {
        inspirationsData: PropTypes.array
    };
    static defaultProps = {
        inspirationsData: []
    };
    constructor() {
        super();
    }
    _renderCollageItem = (inspiration) => {
        return (
            <div key={inspiration.id} className="xs-12 lg-4 txt-center collage-item">
                <span className="xs-12 be-inspired-copy">inspired by</span>
                <h5 className="xs-12 ttl">{inspiration.images.inspiredBy}</h5>
                <img src={inspiration.images.lookBookImage} alt={`LookBook image ${inspiration.images.inspiredBy}`} className="img-responsive use-attributes"/>
                <div className="xs-12">
                    <div className="middle-xs center-xs">
                        <div className="flex-row">
                            <div className="xs-6 txt-right left-btn">
                                <a href={`/en/weddings/ideas/look-book/?inspirationId=${inspiration.id}`} className="inspiration-btn">
                                    CEREMONY
                                </a>
                            </div>
                            <div className="xs-6 txt-left right-btn">
                                <a href={`/en/weddings/ideas/look-book/?inspirationId=${inspiration.id}&isCeremony=false`} className="inspiration-btn">
                                    RECEPTION
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    render() {
        return (
            <div className="look-book-collage-wrapper list">
                <div className="flex-container">
                    <div className="flex-row">
                        { this.props.inspirationsData.map( (inspiration) => this._renderCollageItem(inspiration) ) }
                    </div>
                </div>
            </div>
        );
    }
}
